<template>
    <div class="tablePage">
        <el-table v-loading="loading" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
            :header-cell-style="headCellStyle" :height="tableHeight" @selection-change="handleSelectionChange" stripe>
            <el-table-column type="selection" width="50" />
            <el-table-column v-if="isSys" prop="scopeName" :label="$t('public.table_scope')" show-overflow-tooltip />
            <el-table-column prop="plinthCode" :label="$t('integration.number')" show-overflow-tooltip width="200">
                <template #default="{ row }">
                    <i v-icon:theme="['baseTypeConvert', row.type]"></i>
                    <i v-icon:theme="['baseBindStatusConvert', row.sensorType ? 1 : 0]"></i>
                    <span>{{ row.plinthCode }}</span>
                </template>
            </el-table-column>

<!--            <el-table-column prop="sceneName" :label="$t('public.table_arch')" show-overflow-tooltip />-->
            <el-table-column prop="carrierName" :label="$t('public.table_carrier')" show-overflow-tooltip>
                <template #default="{ row }" >
                  <CardSwipper :list='[row]' >
                    <template #title='{item}'>
                      {{ item.sceneName }}
                    </template>
                    <template #default='{item}'>

                      <div class='uk-flex'>
                        <div style='width: 30px' class='bd-r uk-flex uk-flex-center'>
                          <i class='uk-margin-remove'
                             @click="carrierDetailFn(row.carrierType, row.carrierId)"
                             v-icon="['carrierTypeConvert',row.carrierType]"></i>
                        </div>
                        <div class='uk-flex-1'>
                          {{ item.carrierName }}
                        </div>
                      </div>
                    </template>
                  </CardSwipper>
                </template>
            </el-table-column>

            <el-table-column prop="apMacAddr" :label="$t('integration.vcn_switcher_')" show-overflow-tooltip />
            <el-table-column prop="device" :label="$t('integration.bind_device')" show-overflow-tooltip>
                <template #default="{ row }">
                    <template v-if="row.sensorType">
                        <i v-icon:theme="['sensorTypeConvert', row.sensorType]" @click="selectDevice(row)"></i>
                        <span>{{ row.sensorCode }}</span>
                    </template>
                    <template v-else>
                        <span> --- </span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column prop="description" :label="$t('public.table_desc')" show-overflow-tooltip></el-table-column>
            <el-table-column prop="optare" fixed='right' :label="$t('public.table_operation')" width="160" align="center">
                <template #default="{ row }">
                    <el-button type="text" size="small" v-for="item in optareBtn" :key="item.id" :title="$t(item.title)"
                        :icon="item.icon" @click="handle(item.method, row)"></el-button>
                    <!-- v-has="item.vHas" -->
                </template>
            </el-table-column>
        </el-table>
        <!-- 监测点详情 -->
<!--        <v-dialog :dialogVisible="dialogVisible" :carrierDetail="carrierDetail" :isLoading="isLoading"-->
<!--            @handleClose="handleClose" />-->
      <MonitorDialog :visible.sync='dialogVisible' :carrier-info='carrierDetail'></MonitorDialog>
        <SelectDevice :show.sync="selectDeviceAttrs.selectDeviceShow" :sceneId="selectDeviceAttrs.sceneId"
            :baseId="selectDeviceAttrs.baseId" :current="selectDeviceAttrs.current"
            :carrierName="selectDeviceAttrs.carrierName"></SelectDevice>
        <ExportDialog :isShow.sync="exportDiaShow" :searchForm="eForm" ref="dia" :comNmae="exportProbeHistory">
        </ExportDialog>
    </div>
</template>

<script>
import { carrierDetail, exportProbeHistory } from '@/api/modules/carrier.js'
import prover from '../components/Proper.vue'
import { gatewayTypeConvert, equiStatusConvert, carrierTypeConvert } from '@/utils/convert'
import SelectDevice from '../components/selectDevice/SelectDevice.vue'
import { btnDetail, btnBindHistory } from '../config/operationButton'
import ExportDialog from '@/pages/count/component/exportDialog.vue'
import { getIsSys } from '@/utils/permission'
import CardSwipper from '@/components/CardSwipper/CardSwipper.vue'
import MonitorDialog from '@/pages/equipment/publicCom/MonitorDialog.vue'

export default {
  props: ['loading', 'tableData'],
  components: {
    MonitorDialog,
    CardSwipper,
    'v-popoer': prover,
    SelectDevice,
    ExportDialog
  },
  data () {
    return {
      gatewayTypeConvert,
      equiStatusConvert,
      carrierTypeConvert,
      tableHeight: '100%',
      eForm: {},
      optareBtn: [btnDetail, btnBindHistory],
      isSys: true,
      isLoading: false,
      dialogVisible: false,
      carrierDetail: null,
      typeWay: 'bind',
      exportDiaShow: false,
      selectDeviceAttrs: {
        sceneId: 0,
        selectDeviceShow: false,
        baseId: 0,
        // 当前绑定的sensor
        current: 0
      }
    }
  },

  mounted () {
    this.isSys = getIsSys()
  },
  computed: {
    exportProbeHistory: () => exportProbeHistory
  },
  methods: {
    handleSelectionChange (row) {
      this.$emit('choozeTable', row)
    },
    /** 查找监测点详情 */
    carrierDetailFn (type, carrierId) {
      this.dialogVisible = true
      this.isLoading = true
      carrierDetail(type, carrierId)
        .then(({ result }) => {
          this.carrierDetail = result
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handle (method, row) {
      this.$emit(method, row)
    },
    handleClose () {
      this.dialogVisible = false
    },
    // 选择设备
    selectDevice (row) {
      this.selectDeviceAttrs = {
        selectDeviceShow: true,
        sceneId: row.sceneId,
        baseId: row.id,
        current: row.sensorId,
        carrierName: row.carrierName
      }
    },
    downLoad () {
      const { carrierId, code, time } = this.SearchForm
      const { deviceName, carrierName } = this.$route.query
      if (time.length === 0) return this.$message.warning($t('integration.time_cannot_be_empty'))
      this.eForm = {
        carrierId,
        name: deviceName,
        carrierName,
        code,
        startTime: this.$dateParseTime(time[0]),
        endTime: this.$dateParseTime(time[1])
      }
      this.exportDiaShow = true
      this.$nextTick(() => {
        this.$refs.dia.initForm()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tablePage {
    height: calc(100% - 60px);
}
</style>
